module.exports = __webpack_public_path__ + "img/vertical_3_2_6005.fb46af79.png";